/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

import { Icon } from '..';

const Modal = (props) => (
  <>
    {props.visible && (
      <div className="modal" onMouseDown={props.onClose}>
        <div className="modal_container" onMouseDown={(e) => e.stopPropagation()}>
          <div className="modal_header">
            <h2>
              {props.title}
            </h2>
            <button type="button" onClick={props.onClose}>
              <Icon name="clear" width="1.5em" height="1.5em" />
            </button>
          </div>
          <div className="modal_content">
            {props.children}
          </div>
        </div>
      </div>
    )}
  </>
);

Modal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
};
Modal.defaultProps = {
  title: '',
  onClose: () => {},
};

export default Modal;
